import React, { useState, useEffect } from 'react'

export const AudioList = (props) => {
  const [currentAudio] = useState(null)
  const audios = props.list

  // Announce only when the actual audio URLs change, not when the parent hands
  // down a new array with the same contents. `list` is rebuilt as a fresh array
  // literal on every TokenDisplay render, so keying the effect on array
  // identity replayed the "now serving" announcement on any unrelated re-render
  // (e.g. a reconnect resync) — an announcement loop. Keying on the joined URLs
  // makes an identical token silent while a genuinely new call still plays.
  const audioKey = (audios || []).join('|')

  useEffect(() => {
    toggle(audios[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioKey])

  const toggle = (nextAudio) => {
    if (!nextAudio) return
    const audioObj = new Audio(nextAudio)
    if (audios.indexOf(nextAudio) <= audios.length - 2) {
      audioObj.addEventListener('ended', () =>
        toggle(audios[audios.indexOf(nextAudio) + 1])
      )
    }

    if (currentAudio && currentAudio !== audioObj) {
      currentAudio.pause()
    }
    if (audioObj.paused) audioObj.paused ? audioObj.play() : audioObj.pause()
  }

  return <></>
}
